import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, TierUnit } from "__generated__/graphql";

export const BunkerAdjustmentSchema: RegistryItem = {
	[AgreementTypeEnum.BunkerAdjustment]: {
		defaultValues: {
			calculationMethod: {
				type: null,
				tierUnit: TierUnit.GasoilPrice,
			},
		},
		agreementFields: {
			"agreement.costType": { rules: { hidden: true } },
			"agreement.description": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.tierUnit": { rules: { hidden: true } },
		},
	},
};
